import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TextFillings } from 'src/app/entities/text-fillings.entity/text-fillings';

@Component({
  selector: 'app-reduction-text-form',
  templateUrl: './reduction-text-form.component.html',
  styleUrls: ['./reduction-text-form.component.css']
})
export class ReductionTextFormComponent implements OnInit {

  @Input() submitName: string = 'Submit';
   @Input() textFilligns:TextFillings=new TextFillings({})
   @Output() submit: EventEmitter<TextFillings> = new EventEmitter();
 @Input() disabled:boolean=false
   constructor() { }
 
   ngOnInit(): void {
   }
   _submit(){
 
     this.submit.emit(this.textFilligns)
   }
}
